// DS — tabela liczb w oknie (język minimal, reguła 6).
//
// Trzy wiersze, zawsze te same i zawsze w tej kolejności: Koszt · Masz ·
// Zostanie. To jest INWARIANT PRODUKTU, nie ozdoba okna: koszt w gemach stoi
// przed każdą płatną akcją, a saldo po niej jest tą samą informacją widzianą
// z drugiej strony. Okno, które pyta o gemy bez tych trzech liczb, jest błędem.
//
// Liczby mono i tabelarycznie (`minimal.css`), żeby kolumna cyfr nie drgała
// między „6 gemów” a „128 gemów”. Etykiety przychodzą z zewnątrz: DS nie tłumaczy.
//
// ZWROT GEMÓW TU NIE STOI. „Zwrot gemów: +{n}” mówimy wyłącznie jako fakt
// z ledgera (`refund_confirmed`), więc jego miejsce jest na ekranie, przy serii,
// która naprawdę go dostała — nie w oknie, które dopiero pyta o zgodę.

import type { ReactNode } from 'react'

export interface CostRow {
  /** Etykieta po lewej („Koszt”, „Masz”, „Zostanie”). */
  k: ReactNode
  /** Liczba po prawej — gotowe zdanie z odmienionym rzeczownikiem. */
  v: ReactNode
}

export interface CostTableProps {
  rows: CostRow[]
  className?: string
  'data-testid'?: string
}

export function CostTable({ rows, className = '', ...rest }: CostTableProps) {
  if (rows.length === 0) return null
  return (
    <div className={['mn-nums', className].filter(Boolean).join(' ')} data-testid={rest['data-testid']}>
      {rows.map((r, i) => (
        <div className="mn-nums-row" key={i}>
          <span>{r.k}</span>
          <b>{r.v}</b>
        </div>
      ))}
    </div>
  )
}

export default CostTable
